import React from 'react';
import { Progress as AntProgress } from 'antd';
import './style.css';

const CustomProgress = ({ percent }) => (
  <AntProgress percent={percent} size="large" strokeWidth={8} strokeColor="#1C4E9D"/>
);

export default CustomProgress;
